import script from "./side-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./side-panel.vue?vue&type=script&setup=true&lang=js"

import "./side-panel.vue?vue&type=style&index=0&id=21f871b4&lang=scss&scoped=true"
import "./side-panel.vue?vue&type=style&index=1&id=21f871b4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f871b4"]])

export default __exports__